import { TableCell } from "@mui/material"

export function ImportField({ item: { get }, row }) {
    return <TableCell>{get(row)}</TableCell>
}
